module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADxSURBVHgB7ZTdDYIwFIVvje86AhvICDiBjoAT6ApugBMQNnAD3AA2gA1gg3pq2ljx8pfWBxO+5EDDueHQ9lJBQEq5xS2GdlAL3YQQNfkEIbn8pNLB3gJCyXMhT6wGPH8zUeCri84sGiggn6gXQonem1QtIf0bQl24pbFbeMjXXXiETE0J796tp57uiiy/4Xzo3ONVUDw3pGL8XI6jZjjYwmNEE2pSBG3X5IY6gjI9PtB7Xwyv/XIJqaG91QAJbgV9/8Shy3Jd7Q7U44ypC1xCauZZyTzbuIRMZgn5SUhADix7MgtzrJwYr7bGY77hwdS2T9BVIWRThb4JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/LinkedinFooter.png
// module id = 90
// module chunks = 1